import React, { useState } from 'react';
import { observer } from 'mobx-react';
import {
  ButtonDropdown, Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import { setLanguage } from 'react-switch-lang';
import appState from '../../../storages/mobx/appState';
import { English, Russian, Ukrainian } from '../../../constant';

function LanguageIndicator() {
  const [dropdownOpen, setOpen] = useState(false);
  const handleSetLanguage = (key) => {
    setLanguage(key);
    appState.setCurrentLanguage(key);
  };
  return (
    <>
      {/* <h6 className="language-indicator">{appState.currentLanguage}</h6> */}
      <Dropdown isOpen={dropdownOpen} toggle={() => setOpen(!dropdownOpen)} className="language-dropdownContainer">
        <DropdownToggle caret className="language-indicator" outline color="transparent">
          {appState.currentLanguage}
        </DropdownToggle>
        <DropdownMenu className="language-dropdownMenu">
          <DropdownItem onClick={() => handleSetLanguage('en')}>
            <a href="#javascript" data-lng="en">
              <i className="flag-icon flag-icon-us" />
              {' '}
              {English}
            </a>
          </DropdownItem>
          <DropdownItem onClick={() => handleSetLanguage('ru')}>
            <a href="#javascript" data-lng="ru">
              <i className="flag-icon flag-icon-ru" />
              {' '}
              {Russian}
            </a>
          </DropdownItem>
          <DropdownItem onClick={() => handleSetLanguage('ua')}>
            <a href="#javascript" data-lng="ua">
              <i className="flag-icon flag-icon-ua" />
              {' '}
              {Ukrainian}
            </a>
          </DropdownItem>
          <DropdownItem divider />
        </DropdownMenu>
      </Dropdown>
    </>
  // <h6 className="language-indicator">{appState.currentLanguage}</h6>
  );
}

LanguageIndicator.propTypes = {};

export default observer(LanguageIndicator);
